import type { LogConsoleTransport } from '@speles7172/log-console';
import type {
  LogFacets,
  LogFilter,
  LogSearchResult,
  LogStatistics,
} from '@speles7172/log-client/core';
import { apiClient } from './client';

/**
 * The Logs screen's transport (`LogConsoleTransport`), over `/admin/logs`.
 *
 * The console sends a filter object, never query text; the endpoint compiles
 * it into a CloudWatch Logs Insights query and decides who may read
 * (administrators). A search comes back `running` and the console polls it.
 */
export async function searchLogs(filter: LogFilter): Promise<LogSearchResult> {
  const { data } = await apiClient.post<LogSearchResult>('/admin/logs/search', filter);
  return data;
}

export async function pollLogSearch(request: { queryId: string }): Promise<LogSearchResult> {
  const { data } = await apiClient.post<LogSearchResult>('/admin/logs/poll', request);
  return data;
}

export async function cancelLogSearch(request: { queryId: string }): Promise<void> {
  await apiClient.post('/admin/logs/cancel', request);
}

export async function getLogStatistics(filter: LogFilter): Promise<LogStatistics> {
  const { data } = await apiClient.post<LogStatistics>('/admin/logs/statistics', filter);
  return data;
}

export async function getLogFacets(): Promise<LogFacets> {
  const { data } = await apiClient.get<LogFacets>('/admin/logs/facets');
  return data;
}

export const logsTransport: LogConsoleTransport = {
  search: searchLogs,
  pollSearch: pollLogSearch,
  cancelSearch: cancelLogSearch,
  statistics: getLogStatistics,
  listFacets: getLogFacets,
};
